var _circle, _circle2, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _circle3, _g3, _g4, _path7, _circle4, _g5, _g6, _path8, _circle5, _g7, _g8, _path9, _path0, _path1, _path10, _g9, _circle6, _rect, _g0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchprojectImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 491,
    viewBox: "0 0 491 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 245.742,
    cy: 245.247,
    r: 244.247,
    fill: "white",
    stroke: "url(#paint0_linear_279_150)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "12 12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.741,
    cy: 94.8745,
    r: 43.5083,
    fill: "#547FEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_279_150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.741,
    cy: 149.125,
    rx: 43.5083,
    ry: 5.76615,
    fill: "#B3B3B3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_279_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.608 103.32C274.945 122.022 256 133.404 237.293 128.74C218.594 124.078 207.211 105.134 211.876 86.433C216.537 67.7285 235.482 56.3457 254.183 61.0083C272.888 65.6709 284.271 84.6167 279.607 103.32L279.608 103.32H279.608Z",
    fill: "#547FEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 70.3403L245.425 71.4021V102.21L245.737 102.521L260.037 94.0684L245.737 70.3403Z",
    fill: "#C0CDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 70.3403L231.437 94.0684L245.737 102.521V87.5683V70.3403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 105.229L245.561 105.444V116.418L245.737 116.932L260.046 96.7803L245.737 105.229Z",
    fill: "#C0CDFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 116.932V105.229L231.437 96.7803L245.737 116.932Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 102.521L260.037 94.0685L245.737 87.5684V102.521Z",
    fill: "#7799F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.437 94.0685L245.737 102.521V87.5684L231.437 94.0685Z",
    fill: "#C0CCFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.6207,
    cy: 227.156,
    r: 43.5083,
    fill: "url(#paint1_linear_279_150)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_279_150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.6207,
    cy: 281.406,
    rx: 43.5083,
    ry: 5.76615,
    fill: "#B3B3B3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_279_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.487 235.601C116.824 254.304 97.8793 265.686 79.1725 261.022C60.4735 256.359 49.0903 237.415 53.7555 218.715C58.4166 200.01 77.3613 188.627 96.0623 193.29C114.768 197.952 126.15 216.898 121.487 235.602L121.487 235.601H121.487Z",
    fill: "#7C3EE3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5644 239.267C90.2429 238.779 90.63 237.93 90.5967 237.003L89.8916 230.299L89.5446 225.811L88.7965 219.202C88.7202 218.369 89.1073 217.52 89.8288 216.937L94.1317 213.998C94.8102 213.51 95.7801 213.382 96.6293 213.769L101.347 215.92C102.102 216.264 102.685 216.985 102.813 217.955L103.322 223.088C103.398 223.92 103.011 224.77 102.29 225.352L97.9867 228.291C97.3082 228.78 96.3383 228.908 95.4891 228.52L92.3753 227.101L92.8167 231.633L96.0248 233.095C96.7797 233.439 97.7066 233.406 98.5225 232.866L106.398 227.339C107.077 226.851 107.464 226.002 107.431 225.075L106.428 215.273C106.395 214.346 105.812 213.624 105.057 213.28L96.1879 209.237C95.4331 208.893 94.5062 208.926 93.6903 209.466L85.7715 215.087C85.093 215.576 84.7059 216.425 84.7392 217.352L85.3929 223.918L85.8343 228.45L86.488 235.016C86.5643 235.848 86.1772 236.698 85.4557 237.28L81.2472 240.263C80.5687 240.751 79.5988 240.879 78.7496 240.492L74.0317 238.341C73.2769 237.997 72.6941 237.275 72.5664 236.305L72.014 231.267C71.9377 230.434 72.3248 229.585 73.0463 229.002L77.2548 226.02C77.9333 225.532 78.9032 225.404 79.7524 225.791L82.7718 227.168L82.3305 222.636L79.2167 221.217C78.4618 220.872 77.5349 220.906 76.719 221.446L68.8002 227.067C68.1217 227.555 67.7346 228.405 67.7679 229.331L68.7187 238.996C68.795 239.829 69.3348 240.644 70.184 241.032L79.1479 245.118C79.9028 245.462 80.8297 245.428 81.6456 244.889L89.5644 239.267Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.741,
    cy: 227.156,
    r: 43.5083,
    fill: "#F7931A"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_f_279_150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.741,
    cy: 281.406,
    rx: 43.5083,
    ry: 5.76615,
    fill: "#B3B3B3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_279_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.608 235.601C274.945 254.303 256 265.685 237.293 261.022C218.594 256.359 207.211 237.415 211.876 218.714C216.537 200.01 235.482 188.627 254.183 193.29C272.888 197.952 284.271 216.898 279.607 235.601L279.608 235.601H279.608Z",
    fill: "#F7931A"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.137 222.182C261.832 217.536 258.295 215.039 253.458 213.373L255.027 207.079L251.196 206.125L249.668 212.252C248.661 212.001 247.626 211.764 246.598 211.53L248.137 205.362L244.308 204.407L242.738 210.698C241.904 210.509 241.086 210.321 240.292 210.124L240.296 210.104L235.013 208.785L233.993 212.876C233.993 212.876 236.836 213.528 236.776 213.568C238.327 213.955 238.608 214.982 238.561 215.796L236.774 222.965C236.881 222.992 237.019 223.032 237.172 223.093C237.044 223.061 236.908 223.027 236.767 222.993L234.262 233.036C234.072 233.508 233.591 234.215 232.506 233.946C232.545 234.002 229.722 233.252 229.722 233.252L227.819 237.637L232.805 238.88C233.733 239.112 234.642 239.355 235.537 239.584L233.951 245.95L237.778 246.904L239.348 240.606C240.394 240.89 241.408 241.152 242.402 241.399L240.837 247.667L244.668 248.621L246.254 242.268C252.787 243.504 257.699 243.006 259.767 237.097C261.433 232.34 259.684 229.596 256.247 227.807C258.75 227.23 260.636 225.583 261.139 222.182L261.138 222.181L261.137 222.182ZM252.384 234.455C251.2 239.212 243.189 236.641 240.592 235.996L242.696 227.563C245.293 228.211 253.621 229.494 252.384 234.455H252.384ZM253.569 222.113C252.489 226.44 245.821 224.242 243.659 223.703L245.566 216.054C247.729 216.593 254.694 217.599 253.569 222.113H253.569Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.741,
    cy: 379.111,
    r: 43.5083,
    fill: "#F0B90B"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter6_f_279_150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.741,
    cy: 433.362,
    rx: 43.5083,
    ry: 5.76615,
    fill: "#B3B3B3"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_279_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.608 387.557C274.945 406.259 256 417.641 237.293 412.977C218.594 408.315 207.211 389.371 211.876 370.67C216.537 351.965 235.482 340.582 254.183 345.245C272.888 349.908 284.271 368.854 279.607 387.557L279.608 387.557H279.608Z",
    fill: "#F0B90B"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.218 379.111L232.239 387.051L238.986 391.021V395.669L228.291 389.397V376.79L232.218 379.111ZM232.218 371.172V375.798L228.289 373.474V368.848L232.218 366.523L236.166 368.848L232.218 371.172ZM241.803 368.848L245.732 366.523L249.68 368.848L245.732 371.172L241.803 368.848Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M235.057 385.405V380.757L238.986 383.081V387.708L235.057 385.405ZM241.803 392.686L245.732 395.01L249.68 392.686V397.313L245.732 399.637L241.803 397.313V392.686ZM255.315 368.848L259.244 366.523L263.192 368.848V373.474L259.244 375.798V371.172L255.315 368.848ZM259.244 387.051L259.265 379.111L263.194 376.787V389.395L252.5 395.667V391.019L259.244 387.051Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M256.426 385.405L252.497 387.708V383.081L256.426 380.757V385.405Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256.426 372.817L256.448 377.466L249.682 381.436V389.395L245.754 391.697L241.825 389.395V381.436L235.059 377.466V372.817L239.005 370.493L245.729 374.482L252.495 370.493L256.443 372.817H256.426ZM235.057 364.88L245.732 358.586L256.426 364.88L252.497 367.204L245.732 363.215L238.986 367.204L235.057 364.88Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter8_f_279_150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.862,
    cy: 281.093,
    rx: 43.5083,
    ry: 5.76615,
    fill: "#B3B3B3"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.862,
    cy: 227.468,
    r: 43.5083,
    fill: "#E84142"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 382.959,
    y: 204.005,
    width: 41.3311,
    height: 41.1397,
    fill: "white"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_279_150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.773 227.468C438.773 246.749 423.143 262.379 403.862 262.379C384.582 262.379 368.951 246.749 368.951 227.468C368.951 208.187 384.582 192.557 403.862 192.557C423.143 192.557 438.773 208.187 438.773 227.468ZM393.97 241.361H387.194C385.771 241.361 385.068 241.361 384.639 241.087C384.176 240.786 383.893 240.289 383.858 239.74C383.833 239.234 384.184 238.616 384.887 237.381L401.616 207.894C402.328 206.642 402.688 206.016 403.143 205.785C403.632 205.536 404.215 205.536 404.704 205.785C405.158 206.016 405.519 206.642 406.23 207.894L409.669 213.898L409.687 213.928C410.456 215.272 410.846 215.953 411.016 216.668C411.205 217.448 411.205 218.272 411.016 219.052C410.844 219.773 410.458 220.459 409.678 221.822L400.891 237.356L400.868 237.396C400.094 238.75 399.702 239.436 399.158 239.954C398.567 240.52 397.855 240.932 397.074 241.164C396.362 241.361 395.565 241.361 393.97 241.361ZM411.079 241.361H420.787C422.22 241.361 422.94 241.361 423.369 241.078C423.832 240.778 424.124 240.272 424.15 239.723C424.174 239.234 423.83 238.64 423.156 237.477C423.133 237.437 423.11 237.397 423.086 237.356L418.223 229.037L418.168 228.943C417.485 227.788 417.14 227.204 416.697 226.979C416.208 226.73 415.633 226.73 415.145 226.979C414.699 227.21 414.338 227.819 413.627 229.046L408.781 237.365L408.764 237.393C408.055 238.618 407.7 239.229 407.726 239.732C407.76 240.281 408.043 240.786 408.506 241.087C408.927 241.361 409.647 241.361 411.079 241.361Z",
    fill: "#E84142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_279_150",
    x: 198.233,
    y: 139.359,
    width: 95.0165,
    height: 19.5322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_279_150",
    x: 210.831,
    y: 59.9636,
    width: 69.8218,
    height: 69.8218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_279_150",
    x: 40.1125,
    y: 271.64,
    width: 95.0165,
    height: 19.5322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_279_150",
    x: 52.7098,
    y: 192.245,
    width: 69.8218,
    height: 69.8218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_279_150",
    x: 198.233,
    y: 271.64,
    width: 95.0165,
    height: 19.5322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_279_150",
    x: 210.831,
    y: 192.245,
    width: 69.8218,
    height: 69.8218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_279_150",
    x: 198.233,
    y: 423.595,
    width: 95.0165,
    height: 19.5323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_279_150",
    x: 210.831,
    y: 344.2,
    width: 69.8218,
    height: 69.8219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_279_150",
    x: 356.354,
    y: 271.327,
    width: 95.0165,
    height: 19.5322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_279_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_279_150",
    x: 368.951,
    y: 192.557,
    width: 69.8219,
    height: 69.8218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_279_150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_279_150",
    x1: 245.742,
    y1: 0,
    x2: 245.742,
    y2: 490.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DF23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_279_150",
    x1: 87.6207,
    y1: 183.648,
    x2: 87.6207,
    y2: 270.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9431D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchprojectImg);
export default __webpack_public_path__ + "static/media/launchprojectImg.2a219f4352cb24951825c2465966774d.svg";
export { ForwardRef as ReactComponent };